import React from "react";

/**
 * @author
 * @function Analytic
 **/

export const Analytic = (props) => {
  return <div>Analytic</div>;
};
